export default "__VITE_ASSET__CSYepQ3$__"